export default "__VITE_ASSET__6f8f3600__"